/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  MAXIMIZE_COLUMN(state, data) {
    const stateData = JSON.parse(JSON.stringify(state))
    stateData['maximizeColumn'][data.hash]['type'] = data.type
    state.maximizeColumn = stateData
  }
}
